import React, { FC } from "react";
import { Spin } from "antd";

export type SpinnerProps = {
  show: boolean;
  forceRender?: boolean;
  message?: string;
  className?: string | null;
};

export const Spinner: FC<SpinnerProps> = ({ show, forceRender, message, children, className }) => {
  return (
    <Spin
      spinning={show}
      size="large"
      tip={message || "Loading..."}
      style={{ marginTop: "4em" }}
      {...(className ? { wrapperClassName: className } : {})}
    >
      {!show || forceRender ? children : null}
    </Spin>
  );
};
